import { FormResponseValue } from "@tellescope/types-models";
import { parseTimeAnswer } from "./parse-time-answer";

export const convertStoredResponseToLocal = (response: FormResponseValue): FormResponseValue => {
  if (response.answer.type === "Time" && typeof response.answer.value === "string") {
    const parsed = parseTimeAnswer(response.answer.value);
    if (parsed) return { ...response, answer: { ...response.answer, value: parsed.local } };
  }
  if (
    (response.answer.type === "multiple_choice" || response.answer.type === "Dropdown") &&
    typeof response.answer.value === "string"
  ) {
    return { ...response, answer: { ...response.answer, value: [response.answer.value] } };
  }
  if (response.answer.type === "Database Select" && typeof response.answer.value === "string") {
    return { ...response, answer: { ...response.answer, value: [{ text: response.answer.value }] } };
  }
  return response;
};
